<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert as wgptUserAlert } from 'dashboard/composables/wgpt';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const bot = ref({});
const source = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptBotSources/getUIFlags'];

const description = computed(() => {
  return `${t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.DELETE.CONFIRM.MESSAGE')} ${source.value.name}?`;
});

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('wgptBotSources/delete', {
      botId: bot.value.id,
      id: source.value.id,
    });

    useAlert(
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.DELETE.API.SUCCESS_MESSAGE'
      )
    );
    dialogRef.value.close();
  } catch (error) {
    wgptUserAlert(
      t(
        'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.DELETE.API.ERROR_MESSAGE'
      )
    );
  }
};

const open = (selectedBot, selectedWorkflow) => {
  bot.value = selectedBot;
  source.value = selectedWorkflow;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="
      t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.DELETE.CONFIRM.TITLE')
    "
    :description="description"
    :confirm-button-label="
      t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.DELETE.CONFIRM.YES')
    "
    :cancel-button-label="
      t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.DELETE.CONFIRM.NO')
    "
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
